import React, { useState, useEffect } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PasswordFields from '../components/PasswordFields';
import { passwordPolicyError } from '../utils/passwordPolicy';


function PasswordReset( {handleLogin} ) {
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [verifiedToken, setVerifiedToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null); // [1]
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    navigate('/overview');
  };

  const navigateToSignIn = () => {
    navigate('/signin?password-reset-success=true');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password1 !== password2) {
      console.error('Passwords do not match');

      // set the error message to display
      setErrorMessage('Passwords do not match');
      return;
    }

    const policyError = passwordPolicyError(password1);
    if (policyError) {
      setPasswordError(policyError);
      setErrorMessage(policyError);
      return;
    }

    // Send data to the server for password reset
    const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/password-reset`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        password1,
        password2,
        token: verifiedToken,
      }),
    });

    if (response.ok) {
      navigateToSignIn();

    } else {
      const responseBody = await response.json().catch(() => ({}));
      const serverMessage = responseBody?.error?.message || 'Password reset failed. Please try again.';
      if (/commonly used|data breach/i.test(serverMessage)) setPasswordError(serverMessage);
      setErrorMessage(serverMessage);
    }
  };

  useEffect(() => {
    const url = window.location.href;

    const token = url.split('/').pop();

    // Send data to the server for password reset
    if (token) {
      axios.get(`${process.env.REACT_APP_BACKEND_HOST}/verify-token/${token}`)
      .then(response => {
        if (response.status === 200) {
          // Handle successful token verification here
          setVerifiedToken(token)
        }
      })
      .catch(err => {
        console.error("Token verification failed", err);
        // navigateToSignIn();
      });
    }
  }, []);


  return (
    <div>
      <div className='page-content auth-page'>
        <div className="auth-intro"><span>Account security</span><h1>Get back to your receptionist.</h1><p>Choose a strong new password to restore secure access to your Sayable workspace.</p></div>
        <div className="login-section auth-card">
        <div className="page-title">Set a new password</div>
        <p className="auth-card-subtitle">Enter and confirm your new password below.</p>
        <div className="form-feedback">
              {errorMessage ? errorMessage : ''}
            </div>
          <form onSubmit={handleSubmit}>
            <PasswordFields
              password={password1}
              confirmPassword={password2}
              onPasswordChange={value => {
                setPassword1(value);
                setPasswordError('');
                setErrorMessage(null);
              }}
              onConfirmPasswordChange={setPassword2}
              idPrefix="reset"
              serverError={passwordError}
            />
            <button className="button login-button" onChange={handleSubmit} type="submit">Reset Password</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
